import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { jwtDecode } from "jwt-decode";
import { login as authLogin, refresh as authRefresh, handoff as authHandoff } from "../api/bearcatApiService";

const userStore = create(
  persist(
    (set, get) => ({
      isAuthenticated: false,
      isSuperUser: false,
      token: "",
      refreshToken: "",
      permissions: null,
      userId: "",
      userName: "",
      login: async (username, password, impersonate) => {
        try {
          const data = await authLogin(username, password, impersonate);

          const { isSuccess, result } = data;

          if (isSuccess && result?.isSuperUser) {
            set((state) => ({
              ...state,
              isSuperUser: true,
            }));

            return {
              isSuccess: true,
              isSuperUser: true,
              users: result?.users,
              default: result?.default,
            };
          }

          if (isSuccess) {
            set((state) => ({
              ...state,
              isAuthenticated: true,
              isSuperUser: false,
              token: result?.token,
              refreshToken: result?.refreshToken,
              permissions: result?.security?.permissions,
              userId: result?.userId,
              userName: result?.userName,
            }));
          }
        } catch (error) {
          return error?.response?.data;
        }
      },
      refresh: async () => {
        try {
          const data = await authRefresh(get().refreshToken, get().userId);

          const { isSuccess, result } = data;

          if (isSuccess) {
            set((state) => ({
              ...state,
              token: result?.token,
              refreshToken: result?.refreshToken,
            }));

            return result.token;
          }

          // Non-success response — return current token as fallback
          return get().token;
        } catch (error) {
          const statusId = error?.response?.data?.statusId;

          if (statusId === 401) {
            get().logout();
            return undefined;
          }

          // Non-401 error — return current token as fallback
          return get().token;
        }
      },
      handoff: async (handoffToken) => {
        try {
          const data = await authHandoff(handoffToken);

          const { isSuccess, result } = data;

          if (isSuccess) {
            set((state) => ({
              ...state,
              isAuthenticated: true,
              isSuperUser: result?.isSuperUser,
              token: result?.token,
              refreshToken: result?.refreshToken,
              permissions: result?.security?.permissions,
              userId: result?.userId,
              userName: result?.userName,
            }));
          }
        } catch (error) {
          console.log("Handoff error =>", error);
        }
      },
      logout: async () => {
        set((state) => ({
          ...state,
          isAuthenticated: false,
          isSuperUser: false,
          token: "",
          refreshToken: "",
          permissions: null,
          userId: "",
          userName: "",
        }));
      },
      checkToken: async () => {
        let token = get().token;

        if (token) {
          const decoded = jwtDecode(token);

          if (decoded.exp * 1000 < Date.now()) {
            await get().refresh();
          }
        }
      },
    }),
    {
      name: "user-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default userStore;
